import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseService } from '@cl/core/services';
import { ServiceFactory } from '@cl/core/services/service.factory';
import { BaseModel, EntityType } from '@cl/shared/models';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { InfoModalComponent } from './info-modal/info-modal.component';

@Component({
    selector: 'cl-info-button',
    standalone: false,
    templateUrl: './info-button.component.html',
    styleUrl: './info-button.component.less',
})
export class InfoButtonComponent implements OnInit {
    @Input() entityType: EntityType;
    @Input() id: number;

    @Output() loadingChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    service: BaseService<BaseModel>;

    constructor(private serviceFactory: ServiceFactory, private messageService: NzMessageService, private modalService: NzModalService) {}

    ngOnInit(): void {
        this.service = this.serviceFactory.getService(this.entityType);
    }
    async openEntityInfoModal(): Promise<void> {
        try {
            this.loadingChanged.emit(true);
            const entityInfo: BaseModel = (await this.service.getInfo(this.id)).data;
            this.loadingChanged.emit(false);
            this.modalService.create({
                nzTitle: 'Informācija',
                nzContent: InfoModalComponent,
                nzWidth: 'fit-content',
                nzData: entityInfo,
            });
        } catch (ex) {
            this.loadingChanged.emit(false);
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach((error) => {
                    this.messageService.error(error);
                });
                return;
            }

            this.messageService.error('Kļūda atlasot objekta informāciju');
            return;
        }
    }
}
